import {Button, Tab} from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import {
	selectArticleCount, clearNotificationPanelView,
} from "../../../reducers/notificationPanelArticlesSlice"
import {
	selectCurrentPanelView,
	selectAllPanelViews,
	changePanelView,
	resetSharedArticlesWorkspaceId
} from "../../../reducers/notificationsSlice"
import { clearSelectedArticles } from "../../../reducers/selectedArticlesSlice"
import {NavigationWrapper} from "../../panels/Navigation"
import SecondaryToolbarTabs from "../../../utils/SecondaryToolbarTabs"
import {useMemo} from "react"
import { AssignmentReturnOutlined} from "@mui/icons-material"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export default function NotificationPanelNav() {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const articleCount = useSelector((state) => selectArticleCount(state, workspaceId))
	const tabs = useSelector(selectAllPanelViews)
	const currentPanelView = useSelector((state) => selectCurrentPanelView(state, workspaceId))
	const viewingArticles = useMemo(() => articleCount > 0, [articleCount])

	return(
		<NavigationWrapper>
			{ !viewingArticles && (
				<SecondaryToolbarTabs
					value={currentPanelView}
				>
					{tabs.map((tab, index) => (
						<Tab
							label={tab}
							value={index}
							key={index}
							variant={"secondaryToolBarTab"}
							sx={{
								fontSize: "0.75rem",
							}}
							onClick={() => {dispatch(changePanelView({index, workspaceId}))}}
						/>
					))}
				</SecondaryToolbarTabs>
			)}

			{ viewingArticles && (
				<Button
					variant={"contained"}
					size={"small"}
					sx={{
						marginLeft: "12px",
					}}
					onClick={() => {
						dispatch(clearNotificationPanelView(workspaceId))
						dispatch(resetSharedArticlesWorkspaceId(workspaceId))
						dispatch(clearSelectedArticles(workspaceId))
					}}
					startIcon={
						<AssignmentReturnOutlined />
					}
				>
					Back to Inbox
				</Button>
			)}
		</NavigationWrapper>
	)
}